// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3Ignw","Phantom":"Footer_Phantom__2BRtI","Paragraph":"Footer_Paragraph__9_a0J","Link":"Footer_Link__2UjCb"};